module.exports = __webpack_public_path__ + "img/ee56236cb6ac41798e30bc62a76f892c.cc6b4e45.png";